import { Button } from "reactstrap";
import { dynamicImage, Image } from "../../../../Utils";
import ToDoModal from "./ToDoModal";
import { Fragment } from "react/jsx-runtime";
import { NotesModalType } from "../../../../Types/MessengerType";

const MyToDos: React.FC<NotesModalType> = ({ toggle, modal }) => {
  return (
    <Fragment>
      <div className="converstaion-docs tab-card">
        <div>
          <Image src={dynamicImage("to-do.gif")} alt="to-do" />
        </div>
        <h5>No Open To-Dos Here </h5>
        <p>Just go to the setting &gt; scan with code in the app and log. </p>
        <Button color="primary" size="sm" onClick={toggle}>Create A To-Do</Button>
      </div>
      <ToDoModal modal={modal} toggle={toggle} />
    </Fragment>
  );
};

export default MyToDos;
